var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolidinterfacesearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3849 15.4458C11.7346 17.5685 7.8552 17.4014 5.39842 14.9446C2.76238 12.3086 2.76238 8.0347 5.39842 5.39866C8.03445 2.76262 12.3083 2.76262 14.9444 5.39866C17.4011 7.85544 17.5682 11.7349 15.4456 14.3851L20.6012 19.5408C20.8941 19.8337 20.8941 20.3085 20.6012 20.6014C20.3083 20.8943 19.8334 20.8943 19.5405 20.6014L14.3849 15.4458ZM6.45908 13.8839C4.40882 11.8337 4.40882 8.50957 6.45908 6.45932C8.50933 4.40907 11.8334 4.40907 13.8837 6.45932C15.9324 8.50807 15.9339 11.8288 13.8882 13.8794C13.8867 13.8809 13.8852 13.8824 13.8837 13.8839C13.8822 13.8854 13.8807 13.8869 13.8792 13.8884C11.8286 15.9342 8.50783 15.9327 6.45908 13.8839Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidinterfacesearch);
export default __webpack_public_path__ + "static/media/solidinterfacesearch.8d36133347e487168172307b334318ef.svg";
export { ForwardRef as ReactComponent };